import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-live-race-image-loader',
  templateUrl: './live-race-image-loader.component.html',
  styleUrl: './live-race-image-loader.component.scss',
  standalone: false
})
export class LiveRaceImageLoaderComponent {
  @Input() src: string = "assets/img/bg3.jpg";
  @Input() isFullScreen: boolean = false;
  @Input() displayLoader: boolean = false;

}
